export enum TenantCreationStatus {
    INITIALIZED = 'INITIALIZED',
    SCHEMA_CREATION = 'SCHEMA_CREATION',
    SCHEMA_CREATED = 'SCHEMA_CREATED',
    SYNCING = 'SYNCING',
    SYNCED = 'SYNCED',
    ERROR = 'ERROR',
}
